import moment from "moment";
import React from "react";
import {
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTd,
  StyledTh,
  StyledTr,
} from "./styled";

interface Order {
  amount: number;
  createdAt: string;
  expiredAt: number;
  paymentId: string;
  plan: string;
  _id: string;
}

interface Props {
  data: Order[];
  onDownload: (order: Order) => void;
}

const BillingTable: React.FC<Props> = ({ data, onDownload }) => {
  return (
    <StyledTable>
      <StyledTableHead>
        <StyledTr>
          <StyledTh>Plan</StyledTh>
          <StyledTh>Amount</StyledTh>
          <StyledTh className="qr_id_th">Payment ID</StyledTh>
          <StyledTh>Purchased on</StyledTh>
          <StyledTh>Expires on</StyledTh>
          <StyledTh>Actions</StyledTh>
        </StyledTr>
      </StyledTableHead>
      <StyledTableBody>
        {data.map((row) => (
          <StyledTr key={row._id}>
            <StyledTd className="plan-name">
              {row.plan.split("_").join(" ")}
            </StyledTd>
            <StyledTd>₹{row.amount / 100}/-</StyledTd>
            <StyledTd>{row.paymentId}</StyledTd>

            <StyledTd>{moment(row.createdAt).format("MMM Do, YYYY")}</StyledTd>
            <StyledTd>{moment(row.expiredAt).format("MMM Do, YYYY")}</StyledTd>
            <StyledTd className="invoice-section">
              <span onClick={() => onDownload(row)}>Download invoice</span>
            </StyledTd>
          </StyledTr>
        ))}
      </StyledTableBody>
    </StyledTable>
  );
};

export default BillingTable;
